export default __webpack_public_path__ + "9aaa759fb2a82c4f511fb7811f207f93.svg";